class DnsManagement {
    constructor() {
        this.organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.addCustomDomainNamesFormValidation();
        this.addCustomZoneForwardingFormValidation();
    }
    addCustomDomainNamesFormValidation(){
        const thisClass = this;
        let form = document.getElementById('frm-addCustomDomainNamesForm-addCustomDomainNamesForm');
        if(form){
            let submitButton = document.getElementById('add_custom_domain_names_form_submit');

            // Regex to check if a hostname without a domain is specified
            let hostnameWithoutDomainRegex = /^[-A-Za-z0-9]+$/;
            let hostnameInput = form.querySelector('input[name="hostname"]');
            let hostnameWithoutDomainAlert = form.querySelector('#hostname-without-domain-alert');
            let timeout;
            hostnameInput.addEventListener('input', function () {
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    if (hostnameWithoutDomainRegex.test(this.value)) {
                        hostnameWithoutDomainAlert.classList.remove('d-none');
                    } else {
                        hostnameWithoutDomainAlert.classList.add('d-none');
                    }
                }, 500);
            });

            let validator = FormValidation.formValidation(
                form,
                {
                    fields: {
                        'hostname': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                regexp: {
                                    regexp: /^(\*\.)?([a-zA-Z0-9-]{1,63}(?<!-)\.){0,14}[a-zA-Z]{2,63}$/,
                                    message: 'Bad domain format',
                                },
                                stringLength: {
                                    max: 64,
                                    message: 'Domain cannot be over 64 characters',
                                },
                                remote: {
                                    method: 'POST',
                                    url: '?do=addCustomDomainNamesForm-isDomainUnique',
                                    data: function () {
                                        return {
                                            organizationID: thisClass.organizationID,
                                            hostname: form.querySelector('input[name=hostname]').value,
                                        };
                                    },
                                }
                            },
                        },
                        'ip': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                regexp: {
                                    regexp: /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
                                    message: 'Bad IP format',
                                },
                            },
                        },
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger({
                            delay: {
                                hostname: 0.5
                            },
                        }),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        // defaultSubmit: new FormValidation.plugins.DefaultSubmit(), // Uncomment this line to enable normal button submit after form validation
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.fv-row',
                            eleInvalidClass: '',
                            eleValidClass: ''
                        }),
                    }
                }
            );

            submitButton.addEventListener('click', function (e) {
                // Prevent default button action
                e.preventDefault();
                validator.validate().then(function(status) {
                    if(status === 'Valid'){
                        new DismissModal('add_custom_domain_names_modal').disable();
                        // Show loading indication
                        submitButton.setAttribute('data-kt-indicator', 'on');
                        // Disable button to avoid multiple click
                        submitButton.disabled = true;
                        $('#frm-addCustomDomainNamesForm-addCustomDomainNamesForm').submit();
                    }
                });
            });

            $.nette.ext('addCustomDomainNamesForm', {
                success: function (payload, status, jqXHR, settings) {
                    let formID = settings.nette.form[0].attributes.id.value;
                    if(formID === 'frm-addCustomDomainNamesForm-addCustomDomainNamesForm'){
                        if(payload){
                            toastr.success('Domain has been successfully created!');
                        } else {
                            toastr.error('This domain has been already created or you have exceeded the limit!');
                        }

                        let form = $('#frm-addCustomDomainNamesForm-addCustomDomainNamesForm');
                        new DismissModal('add_custom_domain_names_modal').enable();
                        bootstrap.Modal.getInstance(document.getElementById('add_custom_domain_names_modal')).hide();

                        $('#custom-domain-names-datatable').DataTable().draw();

                        form.find('input[name=hostname]').val('');
                        form.find('input[name=ip]').val('');

                        // Cancel loading indication
                        submitButton.setAttribute('data-kt-indicator', 'off');
                        submitButton.disabled = false;

                        // Set Save Changes button active
                        let saveChangesBtn = document.getElementById('saveChangesBtn');
                        if(saveChangesBtn){
                            saveChangesBtn.disabled = false;
                            let pulseBtn = document.getElementById('saveChangesPulse');
                            if(!pulseBtn){
                                let pulseBtn = document.createElement("span");
                                pulseBtn.classList.add('pulse-ring', 'top-0', 'start-0', 'w-100', 'h-100');
                                pulseBtn.id = 'saveChangesPulse';
                                saveChangesBtn.appendChild(pulseBtn);
                            }
                        }
                        new LeavePageDialog(true);
                    }
                }
            });
        }
    }
    addCustomZoneForwardingFormValidation(){
        const thisClass = this;
        let form = document.getElementById('frm-addCustomZoneForwardingForm-addCustomZoneForwardingForm');
        if(form){
            let zoneInput = form.querySelector('input[name="zone"]');
            if(zoneInput){
                let warningZoneText = document.getElementById('warning-zone-text');
                zoneInput.addEventListener('input', function () {
                    if(this.value.endsWith(".local")) {
                        warningZoneText.classList.remove('d-none');
                    } else {
                        warningZoneText.classList.add('d-none');
                    }
                });
            }

            let submitButton = document.getElementById('add_custom_zone_forwarding_form_submit');

            let validator = FormValidation.formValidation(
                form,
                {
                    fields: {
                        'zone': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                regexp: {
                                    regexp: /^(\*\.)?([a-zA-Z0-9-]{1,63}(?<!-)\.){0,14}[a-zA-Z]{2,63}$/,
                                    message: 'Bad zone format',
                                },
                                stringLength: {
                                    max: 64,
                                    message: 'Zone cannot be over 64 characters',
                                },
                                remote: {
                                    method: 'POST',
                                    url: '?do=addCustomZoneForwardingForm-isZoneUnique',
                                    data: function () {
                                        return {
                                            organizationID: thisClass.organizationID,
                                            zone: form.querySelector('input[name=zone]').value,
                                        };
                                    },
                                }
                            },
                        },
                        'primary_ip': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                regexp: {
                                    regexp: /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
                                    message: 'Bad Resolver IP format',
                                },
                                remote: {
                                    method: 'POST',
                                    url: '?do=addCustomZoneForwardingForm-isResolverIpValid',
                                    data: function () {
                                        return {
                                            organizationID: thisClass.organizationID,
                                            primary_ip: form.querySelector('input[name=primary_ip]').value,
                                        };
                                    },
                                }
                            },
                        },
                        'secondary_ip': {
                            validators: {
                                regexp: {
                                    regexp: /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
                                    message: 'Bad Resolver IP format',
                                },
                                remote: {
                                    method: 'POST',
                                    url: '?do=addCustomZoneForwardingForm-isResolverIpValid',
                                    data: function () {
                                        return {
                                            organizationID: thisClass.organizationID,
                                            secondary_ip: form.querySelector('input[name=secondary_ip]').value,
                                        };
                                    },
                                }
                            },
                        },
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger({
                            delay: {
                                zone: 0.5,
                                primary_ip: 0.5,
                                secondary_ip: 0.5
                            },
                        }),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        // defaultSubmit: new FormValidation.plugins.DefaultSubmit(), // Uncomment this line to enable normal button submit after form validation
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.fv-row',
                            eleInvalidClass: '',
                            eleValidClass: ''
                        }),
                    }
                }
            );

            submitButton.addEventListener('click', function (e) {
                // Prevent default button action
                e.preventDefault();
                validator.validate().then(function(status) {
                    if(status === 'Valid'){
                        new DismissModal('add_custom_zone_forwarding_modal').disable();
                        // Show loading indication
                        submitButton.setAttribute('data-kt-indicator', 'on');
                        // Disable button to avoid multiple click
                        submitButton.disabled = true;
                        $('#frm-addCustomZoneForwardingForm-addCustomZoneForwardingForm').submit();
                    }
                });
            });

            $.nette.ext('addCustomZoneForwardingForm', {
                success: function (payload, status, jqXHR, settings) {
                    let formID = settings.nette.form[0].attributes.id.value;
                    if(formID === 'frm-addCustomZoneForwardingForm-addCustomZoneForwardingForm'){
                        if(payload){
                            toastr.success('Zone has been successfully created!');
                        } else {
                            toastr.error('This zone has been already created or you have exceeded the limit!');
                        }

                        let form = $('#frm-addCustomZoneForwardingForm-addCustomZoneForwardingForm');
                        new DismissModal('add_custom_zone_forwarding_modal').enable();
                        bootstrap.Modal.getInstance(document.getElementById('add_custom_zone_forwarding_modal')).hide();

                        $('#custom-zone-forwarding-datatable').DataTable().draw();

                        form.find('input[name=zone]').val('');
                        form.find('input[name=primary_ip]').val('');
                        form.find('input[name=secondary_ip]').val('');
                        form.find('input[name=includeAllSubdomains]').prop('checked', true);

                        // Cancel loading indication
                        submitButton.setAttribute('data-kt-indicator', 'off');
                        submitButton.disabled = false;

                        // Set Save Changes button active
                        let saveChangesBtn = document.getElementById('saveChangesBtn');
                        if(saveChangesBtn){
                            saveChangesBtn.disabled = false;
                            let pulseBtn = document.getElementById('saveChangesPulse');
                            if(!pulseBtn){
                                let pulseBtn = document.createElement("span");
                                pulseBtn.classList.add('pulse-ring', 'top-0', 'start-0', 'w-100', 'h-100');
                                pulseBtn.id = 'saveChangesPulse';
                                saveChangesBtn.appendChild(pulseBtn);
                            }
                        }
                        new LeavePageDialog(true);
                    }
                }
            });
        }
    }
}
window.DnsManagement = DnsManagement;